import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-right",
  "use": "icon-arrow-right-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"icon-arrow-right\">\n    <path d=\"M15.8906 6.96094L14.8359 8.03906L18.0469 11.25L3 11.25V12.75L18.0469 12.75L14.8359 15.9609L15.8906 17.0391L20.9297 12L15.8906 6.96094Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol